import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VJDistSearchComponent } from './vjdist-search/vjdist-search.component';
import { VJOfficeLocationsComponent } from './vjoffice-locations/vjoffice-locations.component';
import { NgZorroAntdModule } from '../ng-zorro-antd.module';
import { PublicWebsRoutingModule } from './public-web-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { MsalInterceptor } from '@azure/msal-angular';
import { MessageModule } from 'primeng/message';

@NgModule({
  declarations: [
    VJDistSearchComponent,
    VJOfficeLocationsComponent
  ],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    PublicWebsRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TableModule,
    MessageModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PublicWebModule { }
